const MONTH_NAME_PATTERN =
  'jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|' +
  'jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?'

const RE_NUMERIC_DATE = /\b\d{1,2}[/\-.]\d{1,2}[/\-.]\d{2,4}\b/g
const RE_ISO_DATE = /\b\d{4}-\d{1,2}-\d{1,2}\b/g
const RE_MONTH_YEAR = new RegExp(`\\b(?:${MONTH_NAME_PATTERN})\\s+\\d{4}\\b`, 'gi')
const RE_HASH_REF = /#\d+\b/g
const RE_QTY_SUFFIX = /\bqty\.?:?\s*\d+\b/gi
const RE_X_QTY_SUFFIX = /\bx\d+\b/gi
const RE_LONG_NUMBER = /\b\d{3,}\b/g
const RE_WHITESPACE = /\s+/g

const PUNCTUATION_STRIP = '.,;:!?-_—–/\\|@#$%^&*()[]{}"\'`~'

function stripPunctuation(text: string): string {
  let start = 0
  let end = text.length
  while (start < end && PUNCTUATION_STRIP.includes(text.charAt(start))) start += 1
  while (end > start && PUNCTUATION_STRIP.includes(text.charAt(end - 1))) end -= 1
  return text.slice(start, end)
}

/**
 * Lowercase and strip transactional noise from a line description.
 * Mirrors `normalize_line_description` in qbo_transaction_search_service.py.
 */
export function normalizeLineDescription(text: string): string {
  if (!text) return ''

  let normalized = text.toLowerCase().trim()
  normalized = normalized.replace(RE_WHITESPACE, ' ')
  normalized = normalized.replace(RE_NUMERIC_DATE, ' ')
  normalized = normalized.replace(RE_ISO_DATE, ' ')
  normalized = normalized.replace(RE_MONTH_YEAR, ' ')
  normalized = normalized.replace(RE_HASH_REF, ' ')
  normalized = normalized.replace(RE_QTY_SUFFIX, ' ')
  normalized = normalized.replace(RE_X_QTY_SUFFIX, ' ')
  normalized = normalized.replace(RE_LONG_NUMBER, ' ')
  normalized = normalized.replace(RE_WHITESPACE, ' ').trim()
  return stripPunctuation(normalized).trim()
}

/** Stable key for ignored vendor + normalized description pairs. */
export function descriptionIgnoreKey(contactName: string, normalizedDescription: string): string {
  const contact = (contactName || '').trim()
  const norm = (normalizedDescription || '').trim()
  return `${contact}\0${norm}`
}
